import React from 'react';
import ReactHintFactory from 'react-hint'
import JsUtility from '../utils/utility';

export class InfiniteScrollComponent extends React.Component{
    constructor(props) {
       super(props)
       this.scrollY=0;
       this.yBottom=100;
       this._bindScroll=this._bindScroll.bind(this);
       this._onScroll=this._onScroll.bind(this);
    }
    componentDidMount() {
      window.addEventListener('scroll', this._bindScroll, false);
    }
    componentWillUnmount() {
      window.removeEventListener('scroll', this._bindScroll, false);
    }
    _bindScroll(){
      window.requestAnimationFrame(this._onScroll);
    }
    _onScroll = () => {
      var cond1=window.innerHeight + window.scrollY;
      var cond2=document.body.offsetHeight - this.yBottom;
      if ((cond1) >= (cond2) && (window.scrollY > this.scrollY)) {
          this.scrollY=window.scrollY; 
          this.onScroll();
      }else if((cond1) >= (cond2) && (this.scrollY > window.scrollY)){
          this.scrollY=window.scrollY; 
      }
    }
    onScroll(){

    }
}

export class ScrollComponent extends React.Component {
    constructor(props) {
        super(props)
        this.scrollY = 0;
        this.yTop = this.props.yTop || 100;

    }
    componentDidMount() {
        window.addEventListener('scroll', this._bindScroll, false);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this._bindScroll, false);
    }

    _bindScroll = () => {
        window.requestAnimationFrame(this._onScroll);
    }

    _onScroll = () => {
        if (window.scrollY > this.yTop) {
            this.onScroll(window.scrollY);
        }
    }

    onScroll() {

    }
}

export class HttpWorkerComponent extends React.Component {
    constructor(props) {
       super(props)
       this.httpWorker=null;
       this.httpUrl=null;
       this.httpMethod='POST';
       this.request=this.request.bind(this);
    }
    componentDidMount() {
        if(Worker){
          this.worker=new Worker(this.httpWorker);
        }
    }
    componentWillUnmount() {
       console.log('worker terminated'); 
       this.worker.terminate();
    }
    request(entity,...params){
       var postEntity={
           value:entity,
           url:this.httpUrl,
           method:this.httpMethod
       };
       if(params.length==1){
           postEntity.url=params[0];
       }else if(params.length==2){
           postEntity.url=params[0];
           postEntity.method=params[1];
       }
       let worker=this.worker;
       worker.postMessage(postEntity);
       worker.onmessage = (e) => this._onRequestComplete(e.data);
    }
    _onRequestComplete(data){
        this.onRequestComplete(data);
    }
    onRequestComplete(data){

    }
    terminateWorker(){
        if(this.worker) this.worker.terminate();
    }
} 

export class HttpComponent extends React.Component {
    constructor(props) {
       super(props)
       this.httpUrl=null;
       this.httpMethod='POST';
       this.httpRequest=this.httpRequest.bind(this);
    }
    httpRequest(entity,...params){
       var postEntity={
           value:entity,
           url:this.httpUrl,
           method:this.httpMethod
       };
       if(params.length==1){
           postEntity.url=params[0];
       }else if(params.length==2){
           postEntity.url=params[0];
           postEntity.method=params[1];
       }
       this._httpRequest(postEntity);
    }
    _httpRequest(postEntity){
        JsUtility.httpRequest(postEntity.url,postEntity.value,postEntity.method,(err,data)=>{
             if(err){
                 postEntity.error=err;
                 postEntity.value=null;
             }else{
                 postEntity.error=null;
                 postEntity.value=data;
             }
             this.onHttpRequestComplete(postEntity);
        });
    }
    onHttpRequestComplete(data){

    }
}

/// Tooltip
export const ReactHint = ReactHintFactory(React)

/// SOCIAL BUTTONS
export class SocialButtons extends React.Component {
    constructor(props) {
       super(props)
    }

    onFacebookClick(event){
       var url = encodeURI(this.props.url);
       var text = encodeURI(this.props.title);
       var URL = 'https://www.facebook.com/share.php?u=' + url + '&title=' + text;
       this.launchWindow(URL);
    }

    onTwitterClick(event){
       var url = encodeURI(this.props.url);
       var text = encodeURI(this.props.title);
       var URL = 'https://twitter.com/share?url=' + url + '&text=' + text;
       this.launchWindow(URL);
    }

    onGoogleClick(event){
       var url = encodeURI(this.props.url);
       var URL = 'https://plus.google.com/share?url=' + url;
       this.launchWindow(URL);
    }

    onPinterestClick(event){
       var url = encodeURI(this.props.url);
       var text = encodeURI(this.props.title);
       var media = encodeURI(this.props.media);
       var URL = 'https://pinterest.com/pin/create/bookmarklet/?media=' + media + '&url=' + url + '&is_video=false&description=' + text;
       this.launchWindow(URL);
    }

    launchWindow(url) {
        window.open(url);
    }

    render(){
        return(
            <div className="social-buttons">
               <i className="icon-social-media-facebook" onClick={this.onFacebookClick.bind(this)} />
               <i className="icon-social-media-pinterest" onClick={this.onPinterestClick.bind(this)} />
               <img src="/images/icons/social/google.svg" onClick={this.onGoogleClick.bind(this)}  />
               <i className="icon-social-media-twitter" onClick={this.onTwitterClick.bind(this)} />
            </div>
        );
    }
}

export class ShareIcons extends React.Component {
    constructor(props) {
       super(props)
    }

    render(){
        return(
            <section className="share">
               <span>Share:</span>
               <SocialButtons url={this.props.url} title={this.props.title} media={this.props.media} />
            </section>
        );
    }
}

export class PictureImage extends React.Component{
    constructor(props){
        super(props)
    }

    getMobileSrc(src){
        if(src.indexOf('.jpg')>-1){
            src=src.replace('.jpg','');
            src+='_mobile.jpg';
            return src;
        }else if(src.indexOf('.png')>-1){
            src=src.replace('.png','');
            src+='_mobile.png';
            return src;
        }else if(src.indexOf('.jpeg')>-1){
            src=src.replace('.jpeg','');
            src+='_mobile.jpeg';
            return src;
        }else{
            return src;
        }
    }

    render(){
        var src=this.props.src;
        var mobileSrc=this.getMobileSrc(src);
        return(
            <picture>
              <source media="(min-width: 641px)" srcSet={src} />
              <source media="(max-width: 640px)" srcSet={mobileSrc} />
              <img src={src} />
            </picture> 
        );
    }
}

export default{
    InfiniteScrollComponent,
    ScrollComponent,
    HttpWorkerComponent,
    HttpComponent,
    ReactHint,
    SocialButtons,
    ShareIcons,
    PictureImage
}